export const LANGUAGE_EN = 'en';
export const LANGUAGE_DE = 'de';
